import { Box } from '@mui/material';
import React from 'react';

import { CalendarAnnualSummary } from './CalendarAnnualSummary/CalendarAnnualSummary';
import { CalendarPlanner } from './CalendarPlanner/CalendarPlanner';
import { HolidayBookingsModal } from './HolidayBookingsModal';
import { SetupEntitlementDialog } from './SetupEntitlementDialog/SetupEntitlementDialog';

interface CalendarProps {
  isLoading: boolean;
  isPlannerLoading: boolean;
  plannerError: string;
}

export function Calendar({ isLoading, isPlannerLoading, plannerError }: CalendarProps) {
  return (
    <Box>
      <CalendarPlanner
        plannerError={plannerError}
        isLoading={isPlannerLoading}
        currentDate={new Date()}
      />
      <CalendarAnnualSummary isLoading={isLoading} addAbsence={false} />
      <HolidayBookingsModal />
      <SetupEntitlementDialog />
    </Box>
  );
}
